import React, { CSSProperties } from "react";
import { SerializedStyles, css } from "@emotion/react";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { Link as LinkT, Maybe } from "@swo/shared";
import { Link } from "react-router";
import cn from "classnames";
import { CSS_MQ } from "../../styles/breakpoints";

export const IntendedUseCard: React.FC<
  React.PropsWithChildren<{
    attachStyles?: SerializedStyles;
    style?: CSSProperties | undefined;
    link: Maybe<Omit<LinkT, "label">>;
    hasBorderRadius: boolean;
  }>
> = ({ attachStyles, style, link, hasBorderRadius, children }) => {
  const combinedStyles = [
    attachStyles,
    css`
      ${CSS_MQ.atLeastSm} {
        aspect-ratio: 3/4;
      }

      &.has-border-radius {
        border-radius: 8px;
        border: 1px solid ${CSS_COLORS.Gray2024};
      }

      text-decoration: none;
    `,
  ];

  const props = {
    className: cn("u-flex u-flex-col u-relative", { "has-border-radius": hasBorderRadius }),
    css: combinedStyles,
    style: style,
  };

  return link ? (
    <Link to={link.data.pathname} {...props}>
      {children}
    </Link>
  ) : (
    <div {...props}>{children}</div>
  );
};
